import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';

let apolloClient: ApolloClient<NormalizedCacheObject> | null = null;

export function setApolloClient(client: ApolloClient<NormalizedCacheObject>) {
  apolloClient = client;
}

export function getApolloClient() {
  if (!apolloClient) {
    throw new Error('Apollo client not initialized');
  }
  return apolloClient;
}
